import { Box, Alert } from "@mui/material";

export const ErrorState = ({ error }: { error: string }) => (
  <Box p={2}>
    <Alert severity="error">{error}</Alert>
  </Box>
);
